export const ANSWER_TYPE = {
  Single: 'single_choice',
  Multi: 'multiple_choice'
}

export const UNIT_TYPE = {
  Exam: 'exam',
  Exercise: 'exercise'
}

export const IMPL_QUESTION_TYPE = {
  normal: 1,
  bookmarked: 2,
  prev_missed: 3,
}

export const QUESTION_ORDER_TYPE = {
  Sequential: 'sequential',
  Random: 'random'
}

export const ROLE = {
  ADMIN: 'ADMIN',
  CORP_USER: 'CORP_USER'
}
